export default __webpack_public_path__ + "static/img_3_2-c4a695bde87e10349d1152819933b1fd.jpg";